export enum CoverageCollectionLabelEnum {
    Default = 'Default label',
    Base = 'Base label',
    Extra = 'Extra label',
}
